var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page',{attrs:{"hideBottomBar":_vm.user ? false : true,"container":"","title":_vm.$vuetify.lang.t('$vuetify.terms_and_conditions_title')}},[(_vm.lang == 'en')?_c('EnglishTerms'):(_vm.lang == 'nl')?_c('DutchTerms'):_c('FrenchTerms')],1)}
var staticRenderFns = []

export { render, staticRenderFns }